import { Container } from "reactstrap";
import cn from "classnames";
import styles from "./styles.module.scss";

export const Content = ({ className, title, content, heading, fullWidth }) => {
  return (
    <section className={cn(styles.root, className, { [styles.fullWidth]: fullWidth })}>
      <Container fluid={fullWidth} className={cn(fullWidth == true ? "p-0" : "py-4")}>
        {title && (
          <h2 className={cn(styles.title, heading, "fw-bold")}>{title}</h2>
        )}
        <div
          className={cn(styles.desc)}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </Container>
    </section>
  );
};

export default Content;
